
<template>

  <!-- Bootstrap CDN -->
  <div class="jb-box" v-if="!is_logged_in" style="position: relative">
    <video muted autoplay loop>
      <source
        src="https://bizstudy.useschool.co.kr/img/out.mp4"
        type="video/mp4"
      />
      <strong>Your browser does not support the video tag.</strong>
    </video>
    <div class="jb-text" style="opacity: 0.95">
      <div class="container">
        <div
          class="row justify-content-center"
          style="
            position: absolute;
            width: 1350px;
            top: 40%;
            left: 50%;
            transform: translate(-50%, -50%);
          "
        >
          <div class="col-lg-5">
            <div
              class="card shadow-lg border-0 rounded-lg"
              style="margin-top: none"
            >
              <div class="card-header">
                <h3 class="text-center font-weight-light my-4">
                  <img
                    src="/img/mypath_logo.png"
                    style="width: 90%"
                  />
                </h3>
              </div>
              <div class="card-body">
                <div style="text-align: center" v-if="login_in_process">
                  <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                  <br />
                  잠시만 기다려주세요. 로그인을 시도하는 중입니다.
                </div>
                <form @submit.prevent="login()" v-if="!login_in_process">
                  <div class="form-floating mb-3">
                    <input
                      class="form-control"
                      id="inputEmail"
                      type="text"
                      placeholder="name@example.com"
                      v-model="username"
                    />
                    <label for="inputEmail">아이디</label>
                  </div>
                  <div class="form-floating mb-3" style="text-align: center">
                    <input
                      class="form-control"
                      id="inputPassword"
                      type="password"
                      placeholder="Password"
                      v-model="password"
                    />
                    <label for="inputPassword">비밀번호</label>
                    <button
                      class="w-btn w-btn-gra2 w-btn-gra-anim"
                      type="submit"
                      v-on:click="login()"
                      style="margin-top: 24px"
                    >
                      로그인
                    </button>
                  </div>
                </form>
              </div>
              <div class="card-footer text-center py-3">
                계정 분실 시 고객센터 1522-3451 으로 문의주세요.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <link
    type="text/css"
    href="https://cdn.jsdelivr.net/npm/simple-datatables@latest/dist/style.css"
    rel="stylesheet"
  />
  <div
    class="spinner-border text-primary"
    style="position: absolute; left: 50%; top: 50%; z-index: 9999"
    role="status"
    v-if="networkCnt"
  >
    <span class="sr-only">Loading...</span>
  </div>
  
  <div v-if="is_logged_in">
    <nav
      class="d-print-none sb-topnav navbar navbar-expand"
      style="background: #444444; border-bottom: 1px solid #333"
    >
      <!-- Navbar Brand-->
      <router-link class="navbar-brand ps-3" to="/boards/announce/articles"
        ><img src="./assets/img/logo_white.png"
      /></router-link>
      <button
        class="btn btn-link btn-sm order-1 order-lg-0 me-4 me-lg-0"
        id="sidebarToggle"
        href="#!"
        onclick="toggleBtn1()"
      >
        <i class="fa-sharp fa-solid fa-bars fa-2xl" style="color: #d4d4d4"></i>
      </button>
      <!-- Navbar Search-->

      <form
        class="d-none d-md-inline-block form-inline ms-auto me-0 me-md-3 my-6 my-md-0"
      >
        <div
          class="accordion"
          id="accordionExample"
          style="
            width: 140px;
            position: absolute;
            top: 8px;
            right: 20px;
            background: none;
          "
        >
          <div
            class="accordion-item"
            style="border: none; background: none; font-size: 12px"
          >
            <h2 class="accordion-header" id="headingOne">
              <button
                v-if="you"
                class="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
                style="
                  font-size: 12px;
                  padding: 6px 10px;
                  text-align: center;
                  background: #eb4e4e;
                  color: #fff;
                  width: 100%;
                "
              >
                {{ you.name }}
              </button>
            </h2>
            <div
              id="collapseOne"
              class="accordion-collapse collapse"
              aria-labelledby="headingOne"
              data-bs-parent="#accordionExample"
              style="
                margin: 0;
                background: #fff;
                border: 1px solid #ccc;
                top: -10px;
                left: 2px;
                position: relative;
              "
            >
              <div
                class="accordion-body"
                style="text-align: center; padding: 7px 0 0 0;color:#000!important;"
              >
                <ul
                  class="top_drop"
                  style="list-style-type: none; padding-left: 0"
                >
                  <!--a href=""><li>내정보 수정</li></a-->
                  <a
                    href="https://api.mypathkr.com/oauth/authorize?redirect_uri=https://bizstudy.useschool.co.kr/intro.asp&client_id=usersite"
                    target="_blank"
                    ><li
                      style="padding: 5px 0; border-bottom: 1px dashed #f0f0f0"
                    >
                      학습관
                    </li></a
                  >
                  <template v-if="this.guiPerm == 'ROOT'">
                    <a href="https://mypathkr.com" target="_blank"
                      ><li
                        style="
                          padding: 5px 0;
                          border-bottom: 1px dashed #f0f0f0;
                        "
                      >
                        홈페이지
                      </li></a
                    >
                  </template>
                  <template v-if="this.guiPerm == 'ENTERPRISE'">
                    <template v-for="business in businesses" :key="business.id">
                      <a
                        v-bind:href="
                          'https://' + business.subdomain + '.mypathkr.com'
                        "
                        target="_blank"
                        ><li
                          style="
                            padding: 5px 0;
                            border-bottom: 1px dashed #f0f0f0;
                          "
                        >
                          홈페이지
                        </li></a >
                      <a
                        href=""
                        data-bs-toggle="modal"
                        data-bs-target=".viewmyinfo"
                        @click="showModal(business.id)"
                        ><li
                          style="
                            padding: 5px 0;
                            border-bottom: 1px dashed #f0f0f0;
                          "
                        >
                          학원정보확인
                        </li></a
                      >
                    </template>
                  </template>
                  <template v-if="this.guiPerm == 'CLASS'">
                    <a
                      href=""
                      @click.prevent="enterHomePage(businesses[0].parent_id)"
                      ><li
                        style="
                          padding: 5px 0;
                          border-bottom: 1px dashed #f0f0f0;
                        "
                      >
                        홈페이지
                      </li></a
                    >
                  </template>
                  <a
                    href="https://app.edgenuity.com/?code=UBESTAPRO"
                    target="_blank"
                    ><li
                      style="padding: 5px 0; border-bottom: 1px dashed #f0f0f0"
                    >
                      미국 LMS
                    </li></a
                  >

                  <template
                    v-if="
                      this.guiPerm == 'ENTERPRISE' || this.guiPerm == 'ROOT'
                    "
                  >
                    <template v-for="business in businesses" :key="business.id">
                      <a href="" @click.prevent="enterBookclub(business.id)"
                        ><li
                          style="
                            padding: 5px 0;
                            border-bottom: 1px dashed #f0f0f0;
                          "
                        >
                         북클럽LMS
                        </li></a
                      >
                    </template>
                  </template>
                  <a
                    href="https://childu.co.kr/data/차일드유_LMS 상세매뉴얼.pdf"
                    target="_blank"
                    ><li
                      style="padding: 5px 0; border-bottom: 1px dashed #f0f0f0; font-weight:400;"
                    >
                      <span class="bg bg-warning" style="padding:2px 6px; border-radius:4px;">LMS 메뉴얼</span>
                    </li></a>
                  <template v-if="this.guiPerm == 'CLASS'">
                    <a
                      href=""
                      @click.prevent="enterBookclub(businesses[0].parent_id)"
                      ><li
                        style="
                          padding: 5px 0;
                          border-bottom: 1px dashed #f0f0f0;
                        "
                      >
                        북클럽LMS
                      </li></a
                    >
                  </template>
                  <template v-if="this.guiPerm == 'ROOT'">
                    <a
                      href="http://gdadmin.dishae1.godomall.com/base/login.php"
                      target="_blank"
                      ><li
                        style="
                          padding: 5px 0;
                          border-bottom: 1px dashed #f0f0f0;
                        "
                      >
                        교재몰
                      </li></a
                    >
                  </template>
                  <li style="padding-top: 10px; border: none">
                    <button
                      class="btn btn-danger btn-sm"
                      style="background: #5fc5cf; border: 1px solid #44b9c4"
                      @click.prevent="logout()"
                    >
                      Logout
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="input-group" style="display: none">
        회원검색<input
          class="form-control"
          type="text"
          placeholder="Search for..."
          aria-label="Search for..."
          aria-describedby="btnNavbarSearch"
        />
        <button class="btn btn-info" id="btnNavbarSearch" type="button">
          <i class="bi bi-search"></i>
        </button>
      </div>
      <!-- Navbar-->
      <ul class="navbar-nav ms-auto ms-md-0 me-3 me-lg-4"></ul>
    </nav>

    <div id="layoutSidenav">
      <div id="layoutSidenav_nav" class="d-print-none">
        <nav class="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
          <div class="sb-sidenav-menu">
            <div class="nav">
              <a
                class="nav-link collapsed"
                href="#"
                data-bs-toggle="collapse"
                data-bs-target="#bizBoardsT"
                aria-expanded="false"
                aria-controls="collapseBoardsT"
              >
                <div class="sb-nav-link-icon">
                  <i class="fa-solid fa-sitemap" style="color: #bbb"></i>
                </div>

                사이트 관리
                <div class="sb-sidenav-collapse-arrow">
                  <i class="fas fa-angle-down"></i>
                </div>
              </a>
              <div
                class="collapse"
                id="bizBoardsT"
                aria-labelledby="headingTwo"
                data-bs-parent="#sidenavAccordion"
              >
                <nav
                  class="sb-sidenav-menu-nested nav accordion"
                  id="sidenavAccordionPages"
                >
                  <router-link
                    class="nav-link menu_sub"
                    to="/admins"
                    v-if="this.$root.guiPerm == 'ROOT'"
                  >
                    운영자관리
                  </router-link>
                  <router-link
                    class="nav-link menu_sub"
                    to="/admins"
                    v-if="this.$root.guiPerm == 'ENTERPRISE'"
                  >
                    강사관리
                  </router-link>
                  <router-link
                    class="nav-link menu_sub"
                    to="/boards/announce/articles"
                  >
                    공지사항
                  </router-link>
                  <router-link
                    class="nav-link menu_sub"
                    to="/boards/2022_summer/articles"
                  >
                    이벤트
                  </router-link>
                  <router-link
                    class="nav-link menu_sub"
                    to="/popups"
                    v-if="this.$root.guiPerm == 'ROOT'"
                  >
                    팝업관리
                  </router-link>

                  <router-link
                    class="nav-link menu_sub"
                    to="/boards/QNA/articles"
                  >
                    질문과답변
                  </router-link>
                  
                  <!--router-link class="nav-link menu_sub" to="/ims/history">
                                  문자발송내역
                                </router-link-->
                </nav>
              </div>

              <a
                class="nav-link collapsed"
                v-if="guiPerm == 'ROOT'"
                href="#"
                data-bs-toggle="collapse"
                data-bs-target="#bizPages"
                aria-expanded="false"
                aria-controls="collapsePages1"
              >
                <div class="sb-nav-link-icon">
                  <i class="fa-solid fa-sitemap" style="color: #bbb"></i>
                </div>
                기관관리
                <div class="sb-sidenav-collapse-arrow">
                  <i class="fas fa-angle-down"></i>
                </div>
              </a>
              <div
                class="collapse"
                id="bizPages"
                aria-labelledby="headingTwo"
                data-bs-parent="#sidenavAccordion"
              >
                <nav
                  class="sb-sidenav-menu-nested nav accordion"
                  id="sidenavAccordionPages"
                >
                  <router-link
                    class="nav-link menu_sub"
                    to="/businesses?type=LOCAL"
                  >
                    본부별관리
                  </router-link>
                  <router-link
                    class="nav-link menu_sub"
                    to="/businesses?type=ENTERPRISE"
                  >
                    캠퍼스관리
                  </router-link>
                </nav>
              </div>

              <a
                class="nav-link collapsed"
                href="#"
                data-bs-toggle="collapse"
                data-bs-target="#campus"
                aria-expanded="false"
                aria-controls="collapsePages1"
              >
                <div class="sb-nav-link-icon">
                  <i class="fas fa-school"></i>
                </div>

                CAMPUS 게시판
                <div class="sb-sidenav-collapse-arrow">
                  <i class="fas fa-angle-down"></i>
                </div>
              </a>
              <div
                class="collapse"
                id="campus"
                aria-labelledby="headingTwo"
                data-bs-parent="#sidenavAccordion"
              >
                <nav
                  class="sb-sidenav-menu-nested nav accordion"
                  id="sidenavAccordionPages"
                >
                  <router-link
                    class="nav-link menu_sub"
                    to="/voice"
                    v-if="this.$root.guiPerm == 'ROOT'"
                  >
                    음성게시판 관리
                  </router-link>
                  <router-link
                    class="nav-link menu_sub"
                    to="/boards/teacher/articles"
                  >
                    Teacher Notice
                  </router-link>

                  <router-link
                    class="nav-link menu_sub"
                    to="/boards/enterprise/articles"
                  >
                    캠퍼스 공지사항
                  </router-link>

                  <router-link
                    class="nav-link menu_sub"
                    to="/boards/gaelleoli_website/articles"
                  >
                    캠퍼스 갤러리
                  </router-link>
                  <router-link
                    class="nav-link menu_sub"
                    to="/boards/banner/articles"
                    v-if="
                      this.$root.guiPerm == 'ROOT' ||
                      this.$root.guiPerm == 'ENTERPRISE'
                    "
                  >
                    캠퍼스 배너관리
                  </router-link>
                </nav>
              </div>

              <a
                class="nav-link collapsed"
                href="#"
                data-bs-toggle="collapse"
                data-bs-target="#studentsPages"
                aria-expanded="false"
                aria-controls="collapsePages2"
              >
                <div class="sb-nav-link-icon"><i class="fas fa-user"></i></div>
                회원관리
                <div class="sb-sidenav-collapse-arrow">
                  <i class="fas fa-angle-down"></i>
                </div>
              </a>
              <div
                class="collapse"
                id="studentsPages"
                aria-labelledby="headingTwo"
                data-bs-parent="#sidenavAccordion"
              >
                <nav
                  class="sb-sidenav-menu-nested nav accordion"
                  id="sidenavAccordionPages"
                >
                  <router-link class="nav-link menu_sub" to="/businesses/class">
                    클래스 목록
                  </router-link>
                </nav>

                <a
                  class="nav-link menu_sub"
                  style="background: #383838"
                  href="#"
                  data-bs-toggle="collapse"
                  data-bs-target="#pagesCollapseBoard"
                  aria-expanded="false"
                  aria-controls="pagesCollapseAuth"
                >
                  회원목록
                  <div class="sb-sidenav-collapse-arrow">
                    <i class="fas fa-angle-down"></i>
                  </div>
                </a>
                <div
                  class="collapse"
                  id="pagesCollapseBoard"
                  aria-labelledby="headingOne"
                  data-bs-parent="#sidenavAccordionPages"
                >
                  <nav class="sb-sidenav-menu-nested nav">
                    <router-link class="nav-link menu_sub" to="/students">
                      전체회원
                    </router-link>
                    <router-link
                      class="nav-link menu_sub"
                      to="/students?type=ACTIVE"
                    >
                      정회원
                    </router-link>
                    <router-link
                      class="nav-link menu_sub"
                      to="/students?type=EVENT"
                    >
                      이벤트회원
                    </router-link>
                  </nav>
                </div>

                <!-- 학습점수관리 2014.12.16 iriskim-->
                <a
                  class="nav-link menu_sub"
                  style="background: #383838"
                  href="#"
                  data-bs-toggle="collapse"
                  data-bs-target="#pagesScoreBoard"
                  aria-expanded="false"
                  aria-controls="pagesCollapseAuth"
                   v-if="this.$root.guiPerm == 'ROOT' && is_logged_in"
                >
                  학습점수관리
                  <div class="sb-sidenav-collapse-arrow">
                    <i class="fas fa-angle-down"></i>
                  </div>
                </a>
                <div
                  class="collapse"
                  id="pagesScoreBoard"
                  aria-labelledby="headingOne"
                  data-bs-parent="#sidenavAccordionPages"
                   v-if="this.$root.guiPerm == 'ROOT' && is_logged_in"
                >
                  <nav class="sb-sidenav-menu-nested nav">
                    <router-link class="nav-link menu_sub" to="/students/pointmgr/memberlist">
                      회원점수현황
                    </router-link>
                    <router-link
                      class="nav-link menu_sub"
                      to="/students/pointmgr/pointlist"
                    >
                      학습점수내역
                    </router-link>                   
                  </nav>
                </div>
                 



                <nav
                  class="sb-sidenav-menu-nested nav accordion"
                  id="sidenavAccordionPages"
                >
                  <router-link class="nav-link menu_sub" to="/ims/history">
                    메시지발송내역
                  </router-link>
                </nav>
              </div>

              <a
                class="nav-link collapsed"
                href="#"
                data-bs-toggle="collapse"
                data-bs-target="#orderPages"
                aria-expanded="false"
                aria-controls="collapsePages"
              >
                <div class="sb-nav-link-icon">
                  <i class="fas fa-cart-plus"></i>
                </div>
                <span class="left_title">주문관리</span>
                <div class="sb-sidenav-collapse-arrow">
                  <i class="fas fa-angle-down"></i>
                </div>
              </a>
              <div
                class="collapse"
                id="orderPages"
                aria-labelledby="headingTwo"
                data-bs-parent="#sidenavAccordion"
              >
                <nav
                  class="sb-sidenav-menu-nested nav accordion"
                  id="sidenavAccordionPages"
                >
                  <router-link class="nav-link menu_sub" to="/subscriptions">
                    ID주문내역
                  </router-link>
                  <a
                    class="nav-link menu_sub"
                    href="http://mypathkr.co.kr/"
                    target="_blank"
                  >
                    교재주문
                  </a>
                  <router-link
                    class="nav-link menu_sub"
                    to="/product_manage"
                    v-if="this.$root.guiPerm == 'ROOT'"
                  >
                    상품관리
                  </router-link>
                  <router-link
                    class="nav-link menu_sub"
                    to="/subscription_auto"
                    v-if="this.$root.guiPerm == 'ROOT'"
                  >
                    자동연장주문 관리
                  </router-link>
                </nav>
              </div>

              <a
                class="nav-link collapsed"
                href="#"
                data-bs-toggle="collapse"
                data-bs-target="#study"
                aria-expanded="false"
                aria-controls="collapsePages"
                v-if="
                  this.$root.guiPerm == 'ROOT' ||
                  this.$root.guiPerm == 'LOCAL' ||
                  (this.$root.guiPerm == 'ENTERPRISE' &&
                    this.$root.businesses[0].study_type == 'PLS') ||
                  (this.$root.guiPerm == 'CLASS' &&
                    this.$root.businesses[0].study_type == 'PLS')
                "
              >
                <div class="sb-nav-link-icon"><i class="fas fa-pen"></i></div>

                <span class="left_title">ChildU 학습관리</span>
                <div class="sb-sidenav-collapse-arrow">
                  <i class="fas fa-angle-down"></i>
                </div>
              </a>
              <div
                class="collapse"
                id="study"
                aria-labelledby="headingTwo"
                data-bs-parent="#sidenavAccordion"
              >
                <nav
                  class="sb-sidenav-menu-nested nav accordion"
                  id="sidenavAccordionPages"
                >
                  <a
                    class="nav-link collapsed left_title"
                    style="background: #383838"
                    href="#"
                    data-bs-toggle="collapse"
                    data-bs-target="#pagesstudy"
                    aria-expanded="false"
                    aria-controls="pagesCollapseAuth"
                  >
                    진도관리
                    <div class="sb-sidenav-collapse-arrow">
                      <i class="fas fa-angle-down"></i>
                    </div>
                  </a>
                  <div
                    class="collapse"
                    id="pagesstudy"
                    aria-labelledby="headingOne"
                    data-bs-parent="#pagesstudy"
                  >
                    <nav class="sb-sidenav-menu-nested nav">
                      <router-link
                        class="nav-link menu_sub"
                        to="/studies/american"
                      >
                        진도현황
                      </router-link>
                      <router-link
                        class="nav-link menu_sub"
                        to="/studies/progress_report"
                      >
                        PROGRESS REPORT
                      </router-link>
                      <!--router-link class="nav-link menu_sub" to="/studies/languageList">
                    언어훈련
                    </router-link-->
                    </nav>
                  </div>
                  <!--
                <router-link class="nav-link menu_sub" to="/studies/american">
                  진도관리
                </router-link>
                <router-link class="nav-link menu_sub" to="/studies/american_t" v-if="this.$root.guiPerm == 'ROOT'">
                  진도관리_test
                </router-link>-->
                  <a
                    class="nav-link collapsed left_title"
                    style="background: #383838"
                    href="#"
                    data-bs-toggle="collapse"
                    data-bs-target="#pagesCollapseBoard"
                    aria-expanded="false"
                    aria-controls="pagesCollapseAuth"
                  >
                    숙제관리
                    <div class="sb-sidenav-collapse-arrow">
                      <i class="fas fa-angle-down"></i>
                    </div>
                  </a>
                  <div
                    class="collapse"
                    id="pagesCollapseBoard"
                    aria-labelledby="headingOne"
                    data-bs-parent="#pagesCollapseBoard"
                  >
                    <nav class="sb-sidenav-menu-nested nav">
                      <router-link
                        class="nav-link menu_sub"
                        to="/studies/homework_new"
                      >
                        미국학습
                      </router-link>
                      <router-link
                        class="nav-link menu_sub"
                        to="/studies/language_new"
                      >
                        언어훈련관

                      </router-link>
                    </nav>
                  </div>
                  <router-link
                    class="nav-link menu_sub"
                    to="/studies/manager_score"
                  >
                    학습점수관리
                  </router-link>
                </nav>
              </div>
              <a
                class="nav-link collapsed"
                style="display: none"
                href="#"
                data-bs-toggle="collapse"
                data-bs-target="#als"
                aria-expanded="false"
                aria-controls="collapsePages"
                v-if="
                  this.$root.guiPerm == 'ROOT' ||
                  this.$root.guiPerm == 'LOCAL1' ||
                  (this.$root.guiPerm == 'ENTERPRISE' &&
                    this.$root.businesses[0].study_type == 'ALS') ||
                  (this.$root.guiPerm == 'CLASS' &&
                    this.$root.businesses[0].study_type == 'ALS')
                "
              >
                <div class="sb-nav-link-icon"><i class="fas fa-pen"></i></div>

                <span class="left_title">ALS 학습관리</span>
                <div class="sb-sidenav-collapse-arrow">
                  <i class="fas fa-angle-down"></i>
                </div>
              </a>
              <div
                class="collapse"
                id="als"
                aria-labelledby="headingTwo"
                data-bs-parent="#sidenavAccordion"
              >
                <nav
                  class="sb-sidenav-menu-nested nav accordion"
                  id="sidenavAccordionPages"
                >
                  <router-link
                    class="nav-link menu_sub"
                    to="/studies/americanA"
                  >
                    ALS 진도관리 </router-link
                  ><!--
                <router-link class="nav-link menu_sub" to="/studies/american_t" v-if="this.$root.guiPerm == 'ROOT'">
                  진도관리_test
                </router-link>-->

                  <a
                    class="nav-link collapsed left_title"
                    style="background: #383838"
                    href="#"
                    data-bs-toggle="collapse"
                    data-bs-target="#pagesCollapseBoard"
                    aria-expanded="false"
                    aria-controls="pagesCollapseAuth"
                  >
                    ALS 숙제관리
                    <div class="sb-sidenav-collapse-arrow">
                      <i class="fas fa-angle-down"></i>
                    </div>
                  </a>
                  <div
                    class="collapse"
                    id="pagesCollapseBoard"
                    aria-labelledby="headingOne"
                    data-bs-parent="#sidenavAccordionPages"
                  >
                    <nav class="sb-sidenav-menu-nested nav">
                      <router-link
                        class="nav-link menu_sub"
                        to="/studies/homeworkA"
                      >
                        ALS 미국학습
                      </router-link>
                      <router-link
                        class="nav-link menu_sub"
                        to="/studies/languageA"
                      >
                        ALS 언어훈련
                      </router-link>
                    </nav>
                  </div>
                </nav>
              </div>

              <router-link class="nav-link" to="/studies/manager_grade">
                <div class="sb-nav-link-icon">
                  <i class="fas fa-exchange" style="color: #bbbbbb"></i>
                </div>
                <span class="left_title">학습변경 관리</span>
              </router-link>

              <a
                class="nav-link collapsed"
                href="#"
                data-bs-toggle="collapse"
                data-bs-target="#leveltest"
                aria-expanded="false"
                aria-controls="collapsePages"
              >
                <div class="sb-nav-link-icon">
                  <i class="fas fa-chart-pie" style="color: #bbbbbb"></i>
                </div>
                <span class="left_title">PLS PlacementTest</span>
                <div class="sb-sidenav-collapse-arrow">
                  <i class="fas fa-angle-down"></i>
                </div>
              </a>
              <div
                class="collapse"
                id="leveltest"
                aria-labelledby="headingTwo"
                data-bs-parent="#sidenavAccordion"
              >
                <nav
                  class="sb-sidenav-menu-nested nav accordion"
                  id="sidenavAccordionPages"
                >
                  <router-link
                    class="nav-link menu_sub"
                    to="/studies/leveltest"
                  >
                    PLS PlacementTest 응시
                  </router-link>
                  <router-link
                    class="nav-link menu_sub"
                    to="/studies/manager_leveltest"
                  >
                    PLS PlacementTest 결과
                  </router-link>
                </nav>
              </div>
              <!-- <a class="nav-link collapsed"  href="#" data-bs-toggle="collapse" data-bs-target="#alstest" aria-expanded="false" aria-controls="collapsePages" v-if="this.$root.guiPerm == 'ROOT' || this.$root.guiPerm == 'LOCAL1' || (this.$root.guiPerm == 'ENTERPRISE' && this.$root.businesses[0].study_type == 'ALS') || (this.$root.guiPerm == 'CLASS' && this.$root.businesses[0].study_type == 'ALS')" > -->
              <a
                class="nav-link collapsed"
                href="#"
                data-bs-toggle="collapse"
                data-bs-target="#alstest"
                aria-expanded="false"
                aria-controls="collapsePages"
                target="_blank"
              >
                <div class="sb-nav-link-icon">
                  <i class="fas fa-chart-pie" style="color: #bbbbbb"></i>
                </div>

                <span class="left_title">ALS PlacementTest</span>
                <div class="sb-sidenav-collapse-arrow">
                  <i class="fas fa-angle-down"></i>
                </div>
              </a>
              <div
                class="collapse"
                id="alstest"
                aria-labelledby="headingTwo"
                data-bs-parent="#sidenavAccordion"
              >
                <nav
                  class="sb-sidenav-menu-nested nav accordion"
                  id="sidenavAccordionPages"
                >
                  <router-link class="nav-link menu_sub" to="/studies/alstest">
                    ALS PlacementTest 응시
                  </router-link>
                  <router-link
                    class="nav-link menu_sub"
                    to="/studies/manager_alstest"
                  >
                    ALS PlacementTest 결과
                  </router-link>
                </nav>
              </div>

              <a
                class="nav-link collapsed"
                href="#"
                data-bs-toggle="collapse"
                data-bs-target="#report"
                aria-expanded="false"
                aria-controls="collapsePages"
              >
                <div class="sb-nav-link-icon">
                  <i class="fas fa-file-signature" style="color: #bbbbbb"></i>
                </div>
                <span class="left_title">MyPath 리포트관리</span>
                <div class="sb-sidenav-collapse-arrow">
                  <i class="fas fa-angle-down"></i>
                </div>
              </a>

              <div
                class="collapse"
                id="report"
                aria-labelledby="headingOne"
                data-bs-parent="#sidenavAccordionPages"
              >
                <nav class="sb-sidenav-menu-nested nav">
                  <router-link class="nav-link menu_sub" to="/report">
                    Progress Report
                  </router-link>
                  <router-link class="nav-link menu_sub" to="/mypath_test">
                    Assessment Test
                  </router-link>
                </nav>
              </div>

              <a
                class="nav-link collapsed"
                href="#"
                data-bs-toggle="collapse"
                data-bs-target="#filedata"
                aria-expanded="false"
                aria-controls="collapsePages"
              >
                <div class="sb-nav-link-icon">
                  <i class="fa-solid fa-database" style="color: #bbbbbb"></i>
                </div>
                <span class="left_title">자료관리</span>
                <div class="sb-sidenav-collapse-arrow">
                  <i class="fas fa-angle-down"></i>
                </div>
              </a>
              <div
                class="collapse"
                id="filedata"
                aria-labelledby="headingTwo"
                data-bs-parent="#sidenavAccordion"
              >
                <router-link
                  class="nav-link menu_sub"
                  to="/boards/files/articles"
                >
                  교재자료
                </router-link>
                <router-link
                  class="nav-link menu_sub"
                  to="/boards/operating_files/articles"
                >
                  운영자료
                </router-link>
                <nav
                  class="sb-sidenav-menu-nested nav accordion"
                  id="sidenavAccordionPages"
                ></nav>
              </div>

              <a
                class="nav-link collapsed"
                v-if="this.$root.guiPerm == 'ROOT'"
                href="#"
                data-bs-toggle="collapse"
                data-bs-target="#request"
                aria-expanded="false"
                aria-controls="collapsePages"
              >
                <div class="sb-nav-link-icon"><i class="fas fa-user"></i></div>
                <span class="left_title">신청관리</span>
                <div class="sb-sidenav-collapse-arrow">
                  <i class="fas fa-angle-down"></i>
                </div>
              </a>
              <div
                class="collapse"
                id="request"
                aria-labelledby="headingTwo"
                data-bs-parent="#sidenavAccordion"
              >
                <nav
                  class="sb-sidenav-menu-nested nav accordion"
                  id="sidenavAccordionPages"
                >
                  <router-link
                    class="nav-link menu_sub"
                    to="/requests/franchise_meetings/plans"
                    v-if="this.$root.guiPerm == 'ROOT'"
                  >
                    사업설명회
                  </router-link>
                  <router-link
                    class="nav-link menu_sub"
                    to="/boards/franchise_req/articles"
                    v-if="this.$root.guiPerm == 'ROOT'"
                  >
                    가맹문의
                  </router-link>
                </nav>
              </div>

              <a
                class="nav-link collapsed"
                href="#"
                data-bs-toggle="collapse"
                data-bs-target="#event"
                aria-expanded="false"
                aria-controls="collapsePages"
              >
                <div class="sb-nav-link-icon">
                  <i class="fas fa-gifts" style="color: rgb(187, 187, 187)"></i>
                </div>
                <span class="left_title">이벤트관리</span>
                <div class="sb-sidenav-collapse-arrow">
                  <i class="fas fa-angle-down"></i>
                </div>
              </a>
              <div
                class="collapse"
                id="event"
                aria-labelledby="headingTwo"
                data-bs-parent="#sidenavAccordion"
              >
                <nav
                  class="sb-sidenav-menu-nested nav accordion"
                  id="sidenavAccordionPages"
                >
                <!-- 진행중인 이벤트 메뉴 시작 -->
                <a
                    class="nav-link collapsed left_title"
                    style="background: #383838"
                    href="#"
                    data-bs-toggle="collapse"
                    data-bs-target="#sidenavAccordionPages_2025s"
                    aria-expanded="false"
                    aria-controls="pagesCollapseAuth"
                  >
                    2025 SummerCamp<span
                      class="bg-primary btn-sm"
                      style="padding: 2px; font-size: 10px; margin-left: 4px"
                      >진행</span>
                    <div class="sb-sidenav-collapse-arrow">
                      <i class="fas fa-angle-down"></i>
                    </div>
                  </a>
                  <div
                    class="collapse"
                    id="sidenavAccordionPages_2025s"
                    aria-labelledby="headingOne"
                    data-bs-parent="#sidenavAccordionPages_2025s"
                  >
                    <nav class="sb-sidenav-menu-nested nav">
                      <router-link
                        class="nav-link menu_sub"
                        to="/events/2025_Summer"
                      >
                        신청목록
                      </router-link>
                      <router-link
                        class="nav-link menu_sub"
                        to="/events/2025_Summer_view"
                      >
                        학습현황
                      </router-link>
                      <router-link
                        class="nav-link menu_sub"
                        to="/events/2025Summer"
                      >
                        학습 게시판
                      </router-link>
                      <!--router-link
                        class="nav-link menu_sub"
                        to="/events/2025Summer/history"
                      >
                        게임참여현황
                      </router-link-->
                    </nav>
                  </div>
                  <!-- 메뉴 끝 -->
                  <!-- 종료중인 이벤트 메뉴 시작 -->
                  <a
                    class="nav-link collapsed left_title"
                    style="background: #383838"
                    href="#"
                    data-bs-toggle="collapse"
                    data-bs-target="#sidenavAccordionPages_2024w"
                    aria-expanded="false"
                    aria-controls="pagesCollapseAuth"
                  >
                    2024 Winter Camp<span
                      class="bg-secondary btn-sm"
                      style="padding: 2px; font-size: 10px; margin-left: 4px"
                      >종료</span>
                    <div class="sb-sidenav-collapse-arrow">
                      <i class="fas fa-angle-down"></i>
                    </div>
                  </a>
                  <div
                    class="collapse"
                    id="sidenavAccordionPages_2024w"
                    aria-labelledby="headingOne"
                    data-bs-parent="#sidenavAccordionPages_2024w"
                  >
                    <nav class="sb-sidenav-menu-nested nav">
                      <router-link
                        class="nav-link menu_sub"
                        to="/events/2024_Winter"
                      >
                        신청목록
                      </router-link>
                      <router-link
                        class="nav-link menu_sub"
                        to="/events/2024_Winter_view"
                      >
                        학습현황
                      </router-link>
                      <router-link
                        class="nav-link menu_sub"
                        to="/events/2024Winter"
                      >
                        학습 게시판
                      </router-link>
                      <router-link
                        class="nav-link menu_sub"
                        to="/events/2024Winter/history"
                      >
                        게임참여현황
                      </router-link>
                    </nav>
                  </div>                 
                <a
                    class="nav-link collapsed left_title"
                    style="background: #383838"
                    href="#"
                    data-bs-toggle="collapse"
                    data-bs-target="#sidenavAccordionPages_2024s"
                    aria-expanded="false"
                    aria-controls="pagesCollapseAuth"
                  >
                    2024 SummerCamp<span
                      class="bg-secondary btn-sm"
                      style="padding: 2px; font-size: 10px; margin-left: 4px"
                      >종료</span>
                    <div class="sb-sidenav-collapse-arrow">
                      <i class="fas fa-angle-down"></i>
                    </div>
                  </a>
                  <div
                    class="collapse"
                    id="sidenavAccordionPages_2024s"
                    aria-labelledby="headingOne"
                    data-bs-parent="#sidenavAccordionPages_2024s"
                  >
                    <nav class="sb-sidenav-menu-nested nav">
                      <router-link
                        class="nav-link menu_sub"
                        to="/events/2024_Summer"
                      >
                        신청목록
                      </router-link>
                      <router-link
                        class="nav-link menu_sub"
                        to="/events/2024_Summer_view"
                      >
                        학습현황
                      </router-link>
                      <router-link
                        class="nav-link menu_sub"
                        to="/events/2024Summer"
                      >
                        학습 게시판
                      </router-link>
                      <router-link
                        class="nav-link menu_sub"
                        to="/events/2024Summer/history"
                      >
                        게임참여현황
                      </router-link>
                    </nav>
                  </div>
                  <!-- 종료된 이벤트 메뉴 끝 --> 
                   <!-- 아바타 관리 -->
                  <!-- <a
                    class="nav-link collapsed left_title"
                    style="background: #383838"
                    href="#"
                    data-bs-toggle="collapse"
                    data-bs-target="#sidenavAccordionPages_avatar"
                    aria-expanded="false"
                    aria-controls="pagesCollapseAuth"
                  >
                    아바타관리
                    <div class="sb-sidenav-collapse-arrow">
                      <i class="fas fa-angle-down"></i>
                    </div>
                  </a>
                  <div
                    class="collapse"
                    id="sidenavAccordionPages_avatar"
                    aria-labelledby="headingOne"
                    data-bs-parent="#sidenavAccordionPages_avatar"
                  >
                    <nav class="sb-sidenav-menu-nested nav">
                      <router-link
                        class="nav-link menu_sub"
                        to="/avatar/userList"
                      >
                        사용자현황
                      </router-link>
                    </nav>
                  </div> -->

                  <a
                    class="nav-link collapsed left_title"
                    style="background: #383838; display:none;"
                    href="#"
                    data-bs-toggle="collapse"
                    data-bs-target="#sidenavAccordionPages_new"
                    aria-expanded="false"
                    aria-controls="pagesCollapseAuth"
                  >
                    2023 SummerCamp
                    <div class="sb-sidenav-collapse-arrow">
                      <i class="fas fa-angle-down"></i>
                    </div>
                  </a>
                  <div
                    class="collapse"
                    id="sidenavAccordionPages_new"
                    aria-labelledby="headingOne"
                    data-bs-parent="#sidenavAccordionPages_new"
                  >
                    <nav class="sb-sidenav-menu-nested nav">
                      <router-link
                        class="nav-link menu_sub"
                        to="/events/2023_Summer"
                      >
                        신청목록
                      </router-link>
                      <router-link
                        class="nav-link menu_sub"
                        to="/events/2023_Summer_view"
                      >
                        학습현황
                      </router-link>
                      <router-link
                        class="nav-link menu_sub"
                        to="/events/2023_Summer_learningreview"
                      >
                        학습후기
                      </router-link>
                    </nav>
                  </div>
                  <router-link
                    class="nav-link menu_sub"
                    to="/events/recommender"
                    v-if="
                      this.$root.guiPerm == 'ROOT' ||
                      this.$root.guiPerm == 'ENTERPRISE'
                    "
                    style="display:none;">
                    친구추천 이벤트
                  </router-link>
                  <a
                    class="nav-link collapsed left_title"
                    style="background: #383838; display:none;"
                    href="#"
                    data-bs-toggle="collapse"
                    data-bs-target="#pagesCollapseBoard"
                    aria-expanded="false"
                    aria-controls="pagesCollapseAuth"
                  >
                    2022 Winter
                    <div class="sb-sidenav-collapse-arrow">
                      <i class="fas fa-angle-down"></i>
                    </div>
                  </a>
                  <div
                    class="collapse"
                    id="pagesCollapseBoard12"
                    aria-labelledby="headingOne"
                    data-bs-parent="#sidenavAccordionPages"
                  >
                    <nav class="sb-sidenav-menu-nested nav">
                      <router-link
                        class="nav-link menu_sub"
                        to="/events/2022_Winter"
                      >
                        신청목록
                      </router-link>
                      <router-link class="nav-link menu_sub" to="/events/view">
                        학습현황
                      </router-link>
                      <router-link
                        class="nav-link menu_sub"
                        to="/events/learningreview"
                      >
                        학습후기
                      </router-link>
                    </nav>
                  </div>
                </nav>
              </div>

              <template v-if="this.guiPerm !== 'CLASS'">
                <a
                  class="nav-link collapsed"
                  href="#"
                  data-bs-toggle="collapse"
                  data-bs-target="#pay"
                  aria-expanded="false"
                  aria-controls="collapsePages"
                >
                  <div class="sb-nav-link-icon">
                    <i class="fas fa-won-sign"></i>
                  </div>
                  <span class="left_title">수수료관리</span>
                  <div class="sb-sidenav-collapse-arrow">
                    <i class="fas fa-angle-down"></i>
                  </div>
                </a>
                <div
                  class="collapse"
                  id="pay"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#sidenavAccordion"
                >
                  <nav
                    class="sb-sidenav-menu-nested nav accordion"
                    id="sidenavAccordionPages"
                  >
                    <router-link
                      class="nav-link menu_sub"
                      to="/pay_head"
                      v-if="this.guiPerm != 'ENTERPRISE'"
                    >
                      본부별
                    </router-link>
                    <router-link class="nav-link menu_sub" to="/pay_campus">
                      캠퍼스
                    </router-link>
                    <router-link class="nav-link menu_sub" to="/pay_list">
                      캠퍼스 회원
                    </router-link>
                  </nav>
                </div>
              </template>

              <a
                class="nav-link collapsed"
                v-if="this.$root.guiPerm == 'ROOT'"
                href="#"
                data-bs-toggle="collapse"
                data-bs-target="#statistics"
                aria-expanded="false"
                aria-controls="collapsePages"
              >
                <div class="sb-nav-link-icon">
                  <i class="fas fa-chart-area" style="color: #bbb"></i>
                </div>
                <span class="left_title">통계관리</span>
                <div class="sb-sidenav-collapse-arrow">
                  <i class="fas fa-angle-down"></i>
                </div>
              </a>

              <div
                class="collapse"
                id="statistics"
                aria-labelledby="headingTwo"
                data-bs-parent="#sidenavAccordion"
              >
                <nav
                  class="sb-sidenav-menu-nested nav accordion"
                  id="sidenavAccordionPages"
                >
                  <!-- <router-link class="nav-link menu_sub" to="/stat_fr">
                    아이디 사용현황
                  </router-link> -->
                  <router-link class="nav-link menu_sub" to="/stat_fr_new">
                    아이디 사용현황
                  </router-link>

                  <router-link class="nav-link menu_sub" to="/stat_sales_new">
                    매출
                  </router-link>
                  <router-link class="nav-link menu_sub" to="/stat_id_new">
                    ID
                  </router-link>
                  <!-- <router-link class="nav-link menu_sub" to="/stat_textbook">
                    교재
                  </router-link> -->
                </nav>
              </div>

              <a
                class="nav-link collapsed"
                href="#"
                data-bs-toggle="collapse"
                data-bs-target="#collapsePages"
                aria-expanded="false"
                aria-controls="collapsePages"
                style="display: none"
              >
                <div class="sb-nav-link-icon"><i class="fas fa-home"></i></div>
                <span v-if="guiPerm == 'ENTERPRISE'" class="left_title"
                  >클래스 관리</span
                >
                <span v-if="guiPerm == 'ROOT'" class="left_title"
                  >운영자 관리</span
                >

                <div class="sb-sidenav-collapse-arrow">
                  <i class="fas fa-angle-down"></i>
                </div>
              </a>
              <div
                class="collapse"
                id="collapsePages"
                aria-labelledby="headingTwo"
                data-bs-parent="#sidenavAccordion"
              >
                <nav
                  class="sb-sidenav-menu-nested nav accordion"
                  id="sidenavAccordionPages"
                >
                  <router-link
                    class="nav-link menu_sub"
                    to="/admins"
                    v-if="guiPerm == 'ROOT'"
                  >
                    직원관리
                  </router-link>
                  <router-link
                    class="nav-link menu_sub"
                    to="/admins/tutor"
                    v-if="guiPerm == 'ENTERPRISE'"
                  >
                    강사 리스트
                  </router-link>
                  <router-link class="nav-link menu_sub" to="/businesses/class">
                    클래스 리스트
                  </router-link>

                  <router-link
                    class="nav-link menu_sub"
                    to="/subscriptions"
                    v-if="guiPerm == 'ROOT'"
                  >
                    아이디 관리
                  </router-link>

                  <a
                    class="nav-link"
                    href="http://dishae1.godomall.com"
                    target="_blank"
                    style="display: none"
                  >
                    교재관리
                  </a>

                  <a
                    class="nav-link"
                    href="http://dishae1.godomall.com/goods/goods_list.php?cateCd=001"
                    target="_blank"
                    style="display: none"
                  >
                    물품관리
                  </a>
                  <router-link class="nav-link menu_sub" to="/ims/history">
                    문자발송내역
                  </router-link>
                </nav>
              </div>

              <!-- 추후 개발
            <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#" aria-expanded="false" aria-controls="collapsePages">
              <div class="sb-nav-link-icon"><i class="fas fa-home"></i></div>
              자료관리
              <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
            </a>

            <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#" aria-expanded="false" aria-controls="collapsePages">
              <div class="sb-nav-link-icon"><i class="fas fa-home"></i></div>
              신청관리
              <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
            </a>

            <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#" aria-expanded="false" aria-controls="collapsePages">
              <div class="sb-nav-link-icon"><i class="fas fa-home"></i></div>
              이벤트관리
              <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
            </a>

            <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#" aria-expanded="false" aria-controls="collapsePages">
              <div class="sb-nav-link-icon"><i class="fas fa-home"></i></div>
              수수료관리
              <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
            </a>

            <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#" aria-expanded="false" aria-controls="collapsePages">
              <div class="sb-nav-link-icon"><i class="fas fa-home"></i></div>
              재고관리
              <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
            </a>

            <a class="nav-link collapsed" href="#" data-bs-toggle="collapse" data-bs-target="#" aria-expanded="false" aria-controls="collapsePages">
              <div class="sb-nav-link-icon"><i class="fas fa-home"></i></div>
              통계관리
              <div class="sb-sidenav-collapse-arrow"><i class="fas fa-angle-down"></i></div>
            </a>
-->
            </div>
            <div class="sb-nav-link-icon" style="height:30px"></div>
          </div>
        </nav>
      </div>

      <div
        class="modal fade viewmyinfo"
        tabindex="-1"
        id="viewmyinfoModal"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="viewmyinfo">등록 정보</h5>
            </div>
            <div class="modal-body">
              <table class="table">
                <tbody>
                  <tr>
                    <td class="th_bg">사업자등록번호</td>
                    <td>
                      <span> {{ Tbiz.bizNo }} </span>
                    </td>
                    <td class="th_bg" v-if="this.$root.guiPerm == 'ROOT'">
                      관리자
                    </td>
                    <td class="th_bg" v-if="this.$root.guiPerm == 'ENTERPRISE'">
                      캠퍼스명
                    </td>

                    <td>
                      <span> {{ Tbiz.name }} </span>
                    </td>
                  </tr>
                  <tr>
                    <td class="th_bg">연락처</td>
                    <td>
                      <span> {{ Tbiz.tel }} </span>
                    </td>
                    <td class="th_bg">휴대폰</td>
                    <td>
                      <span> {{ Tbiz.phone }} </span>
                    </td>
                  </tr>
                  <tr>
                    <td class="th_bg">대표자명</td>
                    <td>
                      <span> {{ Tbiz.headName }} </span>
                    </td>

                    <td class="th_bg">이메일</td>
                    <td>
                      <span> {{ Tbiz.email }} </span>
                    </td>
                  </tr>

                  <tr>
                    <td class="th_bg">주 소</td>
                    <td colspan="3">
                      <span> {{ Tbiz.address1 }} </span>

                      <span> {{ Tbiz.address2 }} </span>
                    </td>
                  </tr>
                  <!-- <tr>
                    <td class="th_bg">학원등록번호</td>
                    <td>
                      <span> {{ Tbiz.cam_number }} </span>
                    </td>

                    <td class="th_bg">교습과목</td>
                    <td>
                      <span> {{ Tbiz.cam_class }} </span>
                    </td>
                  </tr>
                  <tr>
                    <td class="th_bg">교습기간</td>
                    <td colspan="3">
                      <span> {{ Tbiz.cam_time }} </span>
                    </td>
                  </tr>
                  <tr>
                    <td class="th_bg">교습비용</td>
                    <td colspan="3">
                      <span> {{ Tbiz.cam_expense }} </span>
                    </td>
                  </tr> -->
                  <tr>
                    <td class="th_bg">은행</td>
                    <td>
                      <span> {{ Tbiz.bankCode }} </span>
                    </td>
                    <td class="th_bg">예금주</td>
                    <td>
                      <span> {{ Tbiz.bankName }} </span>
                    </td>
                  </tr>
                  <tr>
                    <td class="th_bg">계좌번호</td>
                    <td colspan="3">
                      <span> {{ Tbiz.bankNum }} </span>
                    </td>
                  </tr>

                  <tr>
                    <td class="th_bg">학습관ID</td>
                    <td>
                      <span> {{ Tbiz.ag_STID }} </span>
                    </td>
                    <td class="th_bg">학습관PW</td>
                    <td>
                      <span> {{ Tbiz.ag_STPW }} </span>
                    </td>
                  </tr>
                  <tr>
                    <td class="th_bg">쇼핑몰ID</td>
                    <td>
                      <span> {{ Tbiz.ag_SWID }} </span>
                    </td>
                    <td class="th_bg"></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td class="th_bg">도메인</td>
                    <td colspan="3">
                      <span> https://{{ Tbiz.domain }}.mypathkr.com/ </span>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table class="table">
                <tr>
                  <th>학원등록번호</th>
                  <td>
                    <input
                      type="text"
                      class="form-control"
                      v-model="Tbiz.cam_number"
                      placeholder="학원등록번호를 입력하세요"
                      style="font-size: 13px; padding: 10px; background: #f9f9f9;"
                    />
                  </td>
                  <th>교습과목</th>
                  <td>
                    <input
                      type="text"
                      class="form-control"
                      v-model="Tbiz.cam_class"
                      placeholder="교습과목을 입력하세요"
                      style="font-size: 13px; padding: 10px; background: #f9f9f9;"
                    />
                  </td>
                </tr>

                <tr>
                  <th>교습기간</th>
                  <td colspan="3">
                    <input
                      type="text"
                      class="form-control"
                      v-model="Tbiz.cam_time"
                      placeholder="교습기간을 입력하세요"
                      style="font-size: 13px; padding: 10px; background: #f9f9f9;"
                    />
                  </td>
                </tr>
                <tr>
                  <th>교습비용</th>
                  <td colspan="3">
                    <input
                      type="text"
                      class="form-control"
                      v-model="Tbiz.cam_expense"
                      placeholder="교습비용을 입력하세요"
                      style="font-size: 13px; padding: 10px; background: #f9f9f9;"
                    />
                  </td>
                </tr>
                <tr>
                  <td colspan="4" style="text-align: center;">
                    <button
                      class="btn btn-danger"
                      style="padding: 4px 20px;"
                      @click="addTrainingInfo(Tbiz.id)"
                    >
                      작성
                    </button>
                  </td>
                </tr>
              </table>
              <table class="table">
                <tr>
                  <th>인사말</th>
                  <td style="padding: 10px">
                    <textarea
                      style="
                        height: 160px;
                        font-size: 13px;
                        padding:10px;
                        background: #f9f9f9;
                      "
                      type="text"
                      class="form-control"
                      placeholder="여기에 인사말을 작성 .."
                      v-model="Tbiz.intro"
                    ></textarea>
                  </td>
                  <td style="text-align: center; width:100px;">
                    <button
                      class="btn btn-danger" style="padding:4px 10px;"
                      @click="addIntro(Tbiz.id)"
                    >
                      작성
                    </button>
                  </td>
                </tr>
              </table>
            </div>
            <div class="modal-footer flex_center">
              <button
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                닫기
              </button>
            </div>
          </div>
        </div>
      </div>

      <div id="layoutSidenav_content">
        <main>
          <router-view class="container-fluid px-4" />
        </main>
        <footer class="py-4 bg-light mt-auto" style="display: none">
          <div class="container-fluid px-4">
            <div
              class="d-flex align-items-center justify-content-between small"
            >
              <div class="text-muted">
                <p style="font-size: 14px; margin: 0; padding: 10px 0 15px">
                  업체명 : (주)유베스타 ｜ 대표이사 : 박성근 ｜ 대표번호 :
                  1522-3993 주소 : 경기도 안양시 동안구 시민대로 401 (관양동,
                  대륭테크노타운15차) 2012호<br />
                  팩스 : 031-421-2733 ｜ 개인정보 관리 책임자 : 김대만
                  사업자등록번호 : 119-86-37260 ｜통신판매업신고번호 : 제
                  2016-안양동안-0559호
                </p>
              </div>
              <div></div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import VueCookies from "vue-cookies";

import Tree from "./components/Tree";
import Admin from "./components/detail_pages/Admin.vue";
export default {
  name: "Home",
  mounted() {
    var modalList = [];

    axios.defaults.baseURL = "/api";

    var thhis = this;
    // Add a request interceptor
    axios.interceptors.request.use(
      async function (config) {
        // Do something before request is sent
        if (config.url.startsWith("/"))
          config.headers.Authorization =
            "Bearer " + VueCookies.get("access_token");
        //config.headers.refresh_token = VueCookies.get('refresh_token');

        console.log(config);
        thhis.networkCnt++;
        return config;
      },
      function (error) {
        // Do something with request error
        return Promise.reject(error);
      }
    );

    // Add a response interceptor
    axios.interceptors.response.use(
      (response) => {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        thhis.networkCnt--;
        return response;
      },
      async (error) => {
        thhis.networkCnt--;
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        console.log(error);
        console.log("에러일 경우", error.config);
        const errorAPI = error.config;
        if (error.response.data.is_authentication_error) {
          if (error.response.data.is_refreshable) {
            errorAPI.retry = true;
            console.log("토큰이 이상한 오류일 경우");
            if (await refreshToken()) {
              console.log("refresh success!");
              return await axios(errorAPI);
            }
          } else {
            $.notify(
              {
                // options
                message:
                  "로그인 세션이 끊어졌습니다.<br>" + error.response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
            thhis.$root.is_logged_in = false;
            thhis.$root.login_in_process = false;
          }
        } else {
          $.notify(
            {
              // options
              message:
                "서버 요청 중 처리되지 않은 에러가 발생하였습니다.<br>" +
                error.message,
            },
            {
              // settings
              type: "warning",
              z_index: 9999,
            }
          );
        }
        return Promise.reject(error);
      }
    );

    async function refreshToken() {
      let form = new FormData();
      form.append("grant_type", "refresh_token");
      form.append("refresh_token", VueCookies.get("refresh_token"));
      return axios.post("/oauth/login", form).then(async (response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "재로그인에 실패하였습니다. " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
          throw new Error("refresh 로그인 실패 " + response.data.error);

          return false;
        } else {
          VueCookies.set("access_token", response.data.access_token);
          VueCookies.set("refresh_token", response.data.refresh_token);
          $.notify(
            {
              // options
              message: "자동으로 다시 로그인 되었습니다.",
            },
            {
              // settings
              type: "success",
              z_index: 9999,
            }
          );
          return true;
        }
      });
    }

    this.getBusinesses();

    /*
    if(localStorage.getItem("refresh_token")){
            let form = new FormData()
      form.append('grant_type', 'refresh_token')
      form.append('refresh_token', localStorage.getItem("refresh_token"))
      axios.post(this.baseUrl + '/oauth/login', form)
        .then(response => {
          return new Promise((resolve) => {
            if (response.data.error) {
              $.notify({
                // options
                message: '자동로그인에 실패하였습니다. ' + response.data.error
              }, {
                // settings
                type: 'danger',
                z_index: 9999
              });
              localStorage.removeItem("refresh_token")
            } else {
              this.accessToken = response.data.access_token;
              localStorage.setItem('refresh_token', response.data.refresh_token);
              $.notify({
                // options
                message: '자동으로 다시 로그인 되었습니다.'
              }, {
                // settings
                type: 'success',
                z_index: 9999
              });
              resolve(response.data)
            }
          })

        }).then(() => {
          this.getBusinesses();
        })
    }*/
  },
  methods: {
    loadTrees() {},
    logout() {
      axios.post("/oauth/logout").then((response) => {
        return new Promise((resolve) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "로그아웃할 수 없습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            localStorage.removeItem("refresh_token");
            this.accessToken = "";
            this.is_logged_in = false;
            this.login_in_process = false;
            $.notify(
              {
                // options
                message: "로그아웃 되었습니다.",
              },
              {
                // settings
                type: "success",
                z_index: 9999,
              }
            );
            resolve(response.data);
          }
        });
      });
    },
    login() {
      this.login_in_process = true;
      let form = new FormData();
      form.append("grant_type", "password");
      form.append("username", this.username);
      form.append("password", this.password);
      axios
        .post("/oauth/login", form)
        .then((response) => {
          return new Promise((resolve) => {
            this.login_in_process = false;
            if (response.data.error) {
              $.notify(
                {
                  // options
                  message: "로그인할 수 없습니다. " + response.data.error,
                },
                {
                  // settings
                  type: "danger",
                  z_index: 9999,
                }
              );
            } else {
              VueCookies.set("access_token", response.data.access_token);
              VueCookies.set("refresh_token", response.data.refresh_token);
              $.notify(
                {
                  // options
                  message: "로그인 되었습니다.",
                },
                {
                  // settings
                  type: "success",
                  z_index: 9999,
                }
              );
              this.is_logged_in = true;
              this.login_in_process = false;
              resolve(response.data);
            }
          });
        })
        .then(() => {
          this.getBusinesses();
        });
    },
    changeBusiness() {
      this.selectCb = function (biz) {
        this.selBiz = biz;
        this.selectCb = () => {};
        this.$router.push("/");
      };
    },
    getBusinesses() {
      this.login_in_process = true;
      axios.get("/oauth/userinfo").then((response) => {
        this.businesses = response.data.result;
        this.selBiz = this.businesses;
        this.you = response.data.you;
        this.guiPerm = response.data.guiPerm;
        this.is_logged_in = true;

        //console.log(this.you.id);
      });
    },
    enterBookclub(id) {
      axios.get("/businesses/" + id + "/bookclub/lms").then((response) => {
        console.log(response.data);
        if (response.data.error) {
          $.notify(
            {
              // options
              message: response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          var blob = new Blob([response.data], {
            type: "text/html",
          });
          window.open(URL.createObjectURL(blob), "_blank");
        }
      });
    },
    enterHomePage(id) {
      axios.get("/businesses/" + id + "/homepage/lms").then((response) => {
        console.log(response.data);
        if (response.data.error) {
          $.notify(
            {
              // options
              message: response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          this.businesses = response.data.result;
          var blob = "https://" + this.businesses + ".mypathkr.com";
          window.open(blob, "_blank");
        }
      });
    },
    showModal(id) {
      axios.get("/businesses/" + id).then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "데이터를 조회할 수 없습니다. " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          this.Tbiz = response.data.result;
        }
      });
    },
    addIntro(record) {
      axios
        .post("/businesses/" + this.Tbiz.id + "/intro", {
          intro: this.Tbiz.intro,
          expiresAt: 0,
        })
        .then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "수정 실패하였습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            $.notify(
              {
                // options
                message: "수정 성공하였습니다. ",
              },
              {
                // settings
                type: "success",
                z_index: 9999,
              }
            );
          }
        });
    },
    addTrainingInfo(record) {
      axios
        .post("/businesses/" + this.Tbiz.id + "/camInfo", {
          cam_number: this.Tbiz.cam_number,
          cam_class: this.Tbiz.cam_class,
          cam_time: this.Tbiz.cam_time,
          cam_expense: this.Tbiz.cam_expense,
          expiresAt: 0,
        })
        .then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "작성 실패하였습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            $.notify(
              {
                // options
                message: "작성 성공하였습니다. ",
              },
              {
                // settings
                type: "success",
                z_index: 9999,
              }
            );
          }
        });
    },
  },
  data() {
    return {
      is_logged_in: false,
      login_in_process: false,
      username: "",
      password: "",
      baseUrl: `${location.protocol}//${location.hostname}${
        location.port ? ":" + location.port : ""
      }/api`,
      businesses: [],
      selectCb: (id) => {
        console.log(id);
      },
      selBiz: {},
      Tbiz: {},
      you: null,
      guiPerm: "",
      networkCnt: 0,
    };
  },
  components: {
    Tree,
    Admin,
  },
  computed: {
    // Getter, Setter
    accessToken: {
      get() {
        return localStorage.getItem("access_token");
      },
      set(value) {
        localStorage.setItem("access_token", value);
      },
    },
  },
};
</script>
